import { DropdownButton } from '@omnipresentgroup/design-system';
import { ContractorState } from '@omnipresentgroup/types';
import { useState } from 'react';

import { ContractorDeactivationModal } from '../../../../features/contractor-deactivation';

type Props = {
  contractorId: string;
  contractorState: ContractorState;
};

export const ContractorActionCell = ({
  contractorId,
  contractorState,
}: Props) => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <DropdownButton
        icon="Dots"
        aria-label={`contractor-actions-${contractorId}`}
        options={[
          {
            name: 'Deactivate',
            icon: 'Trash',
            onClick: () => {
              setModalOpen(true);
            },
            disabled: contractorState === ContractorState.INACTIVE,
          },
        ]}
      />

      {modalOpen && (
        <ContractorDeactivationModal
          modalProps={{
            open: modalOpen,
            onOpenChange: setModalOpen,
          }}
          handleCancel={() => {
            setModalOpen(false);
          }}
          handleSuccess={() => {
            setModalOpen(false);
          }}
          contractorId={contractorId}
        />
      )}
    </>
  );
};
